/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The type of the emission factor

Values: 0=Basic, 1=Calculated, 2=Other
 * @export
 * @enum {number}
 */

export enum EmissionFactorType {
    Basic = 0,
    Calculated = 1,
    Other = 2
}


